__turbopack_context__.v({
  "panelCenter": "PanelCenter-module__5sJena__panelCenter",
  "panelCenterLeft": "PanelCenter-module__5sJena__panelCenterLeft",
  "panelCenterRight": "PanelCenter-module__5sJena__panelCenterRight",
});
